import React from "react";
import { isNil } from "ramda";
import { Countdown, Button, BoxSpinner } from "components/generic/kit";
import * as native from "components/generic/form/native";
import {
  Input,
  CheckboxList,
  RadioList,
  File,
  Formik
} from "components/generic/form/formik";
import {
  Description,
  Title,
  Row,
  Label,
  ErrorBox,
  Error
} from "components/generic/form/service";
import { NarrowBody, Overlay, Offer } from "components/generic/layout";

export default ({
  initialValues,
  validationSchema,
  step,
  questions,
  onSubmit,
  updateWizardApi,
  isLoading,
  errors,
  offer,
  referralDiscount,
  onLogout
}) => (
  <Overlay
    right={<Overlay.Link onClick={() => onLogout()}>Log out</Overlay.Link>}
  >
    {offer && (
      <Offer>
        {offer.message || (
          <div>
            You've got {offer.discount_str} off on your first call if you
            purchase within the next <Countdown time={offer.expires_at} />
          </div>
        )}
      </Offer>
    )}
    {referralDiscount.data && (
      <Offer>
        <div>Congratulations! You've got 20$ off on your first call</div>
      </Offer>
    )}
    {isLoading ? (
      <BoxSpinner />
    ) : (
      <NarrowBody>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={onSubmit}
          errors={errors.field}
        >
          {props => (
            <div>
              {!!errors.nonField.length && (
                <ErrorBox errors={errors.nonField} />
              )}
              <Title>{step.title}</Title>
              <Description>{step.description}</Description>
              <form onSubmit={props.handleSubmit}>
                {questions.map(
                  ({ id, isRequired, type, label, choices }, i) => (
                    <div key={i}>
                      {i !== 0 && <br />}
                      <Row>
                        <Label title={label}>
                          {type === "CHAR" ? (
                            <Input name={id} type="text" />
                          ) : type === "FILE" ? (
                            <File name={id} />
                          ) : type === "CHOI" ? (
                            <RadioList name={id}>
                              {(value, setValue) =>
                                choices.map(([key, item], i) => {
                                  return key !== "Custom Choice" ? (
                                    <RadioList.Item
                                      key={i}
                                      value={item}
                                      title={item}
                                    />
                                  ) : (
                                    <RadioList.Item
                                      key={i}
                                      value=""
                                      title={item}
                                      checked={
                                        !choices.filter(([_, v]) => v === value)
                                          .length && !isNil(value)
                                      }
                                      children={checked =>
                                        checked && (
                                          <native.Input
                                            value={value}
                                            onChange={e =>
                                              setValue(e.target.value)
                                            }
                                          />
                                        )
                                      }
                                    />
                                  );
                                })
                              }
                            </RadioList>
                          ) : type === "MULT" ? (
                            <CheckboxList name={id}>
                              {choices.map(
                                ([key, item], i) =>
                                  key !== "Custom Choice" ? (
                                    <CheckboxList.Item
                                      key={i}
                                      index={i}
                                      name={item}
                                      title={item}
                                    />
                                  ) : (
                                    <CheckboxList.Item
                                      key={i}
                                      index={i}
                                      name=""
                                      title={item}
                                      children={(value, checked, change) =>
                                        checked && (
                                          <native.Input
                                            value={value}
                                            onChange={e =>
                                              change(e.target.value)
                                            }
                                          />
                                        )
                                      }
                                    />
                                  )
                              )}
                            </CheckboxList>
                          ) : null}
                        </Label>
                      </Row>
                    </div>
                  )
                )}
                {!!updateWizardApi.error &&
                  !!updateWizardApi.error.message && (
                    <Error>{updateWizardApi.error.message} </Error>
                  )}
                <div className="w-100 mt3">
                  <Button type="submit" disabled={updateWizardApi.isFetching}>
                    Submit
                  </Button>
                  <p className="pl2 f7 pt1">
                    By clicking "Submit", you agree to our{" "}
                    <a
                      href="https://thelobby.io/legal/terms"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="link"
                    >
                      Terms &amp; Conditions
                    </a>{" "}
                    and that you have read our{" "}
                    <a
                      href="https://thelobby.io/legal/privacy"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="link"
                    >
                      Privacy Policy
                    </a>{" "}
                  </p>
                </div>
              </form>
            </div>
          )}
        </Formik>
      </NarrowBody>
    )}
  </Overlay>
);



// WEBPACK FOOTER //
// ./src/components/pages/Candidate/ProfileSetup/View.js